export default __webpack_public_path__ + "static/media/copa-airlines.b86a36d7.svg";